import { Checkbox, FormControlLabel, Typography } from '@mui/material';
import { useMaterialUIController } from 'context';
import { useTranslation } from 'react-i18next';
import { getCrmColors } from '../../kanban-board/crm-theme';

interface Props {
    checked: boolean;
    onChange: (checked: boolean) => void;
}

/// Pede a sala do Meet junto com a ação; só aparece com a agenda do Google conectada.
export const AgendaMeetOption = ({ checked, onChange }: Props) => {
    const { t } = useTranslation();
    const [controller] = useMaterialUIController();
    const cc = getCrmColors(controller.darkMode);

    return (
        <FormControlLabel
            sx={{ display: 'flex', ml: -0.75, mr: 0 }}
            control={<Checkbox size="small" checked={checked} onChange={(e) => onChange(e.target.checked)} />}
            label={<Typography sx={{ fontSize: 13, color: cc.textPrimary }}>{t('googleAgenda.criarMeet')}</Typography>}
        />
    );
};

/// A ação vale no CRM mesmo se o Google falhar; o aviso evita contar com evento inexistente.
export const calendarWarning = (
    googleReady: boolean,
    createMeet: boolean,
    result?: { inCalendar: boolean; meetUrl?: string | null } | null,
): string | null => {
    if (!googleReady || !result) return null;
    if (!result.inCalendar) return 'googleAgenda.naoEntrou';
    if (createMeet && !result.meetUrl) return 'googleAgenda.semMeet';

    return null;
};
